<template>
  <div  layoxut="column center-center" class="w100" @click="click(city)">
    <div v-if="!hideLabel" class="city">{{city.name}}</div>
    <div class="container" layout="row top-left">
      <digit-h v-for="n in digits" :active="isActive(n)"/>
    </div>

  </div>


</template>

<script>
    import DigitH from "./DigitH";

    export default {
      components: {DigitH},
      props:['city', 'maxScore', 'hideLabel'],
      name: "score-bar-h",
      data() {
        return {
            digits: 50,
            loaded: false
        }
      },
      mounted() {
      },
      methods: {
        isActive: function(index) {
          const cityScore = this.city.scores.score;
          const scorePerDigit = Math.round(this.maxScore / this.digits);
          const cityDigits = Math.round(cityScore / scorePerDigit);
          console.log('h', index < cityDigits);
          return index < cityDigits;
        },
        click(city) {
          this.$router.push(`/${city.key}`);
        }
      }
    }
</script>

<style scoped>
  .container {
    width:100%;
  }
  .city {
    margin-top: 0.0rem;
    font-size:1.3rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/ScoreBarH.vue